var map = {
	"./progress-cn.png": "erV1",
	"./progress-en.png": "5bl/",
	"./progress-th.png": "wrIt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cNdF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/progress ^\.\/progress\-.*\.png$
// module id = cNdF
// module chunks = 1